export default "__VITE_ASSET__cd56a444__"